import * as React from 'react';
import Dump from "../components/dump";
import { applyDiscount, type Discount } from "../components/discount";
import useSummaryCalculator from "../helpers/useSummaryCalculator";
import { formatPriceWithCurrency, getOfferPrice, isSubscription } from "../index/utils";

type Props = Readonly<{
	offer: {}
	startDate: Date
	discount?: Discount | null
}>

function SummaryMobile({offer, startDate, discount, ...otherProps}: Props) {
	const summary = useSummaryCalculator(startDate, offer);
	const currency = offer?.priceCurrency;
	const { discountedTotal, hasDiscount } = applyDiscount(summary, discount);

	return (<>
		<div className="text-xs">
			{/*<Dump value={summary}/>*/}
			<div className="flex gap-2">
				<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
					<path d="M11.2 11.2C10.423 11.2 9.8 11.823 9.8 12.6C9.8 12.9713 9.9475 13.3274 10.2101 13.5899C10.4726 13.8525 10.8287 14 11.2 14C11.5713 14 11.9274 13.8525 12.1899 13.5899C12.4525 13.3274 12.6 12.9713 12.6 12.6C12.6 12.2287 12.4525 11.8726 12.1899 11.6101C11.9274 11.3475 11.5713 11.2 11.2 11.2ZM0 0V1.4H1.4L3.92 6.713L2.968 8.428C2.863 8.624 2.8 8.855 2.8 9.1C2.8 9.4713 2.9475 9.8274 3.21005 10.0899C3.4726 10.3525 3.8287 10.5 4.2 10.5H12.6V9.1H4.494C4.44759 9.1 4.40308 9.08156 4.37026 9.04874C4.33744 9.01592 4.319 8.97141 4.319 8.925C4.319 8.89 4.326 8.862 4.34 8.841L4.97 7.7H10.185C10.71 7.7 11.172 7.406 11.41 6.979L13.916 2.45C13.965 2.338 14 2.219 14 2.1C14 1.91435 13.9263 1.7363 13.795 1.60503C13.6637 1.47375 13.4857 1.4 13.3 1.4H2.947L2.289 0M4.2 11.2C3.423 11.2 2.8 11.823 2.8 12.6C2.8 12.9713 2.9475 13.3274 3.21005 13.5899C3.4726 13.8525 3.8287 14 4.2 14C4.5713 14 4.9274 13.8525 5.18995 13.5899C5.4525 13.3274 5.6 12.9713 5.6 12.6C5.6 12.2287 5.4525 11.8726 5.18995 11.6101C4.9274 11.3475 4.5713 11.2 4.2 11.2Z" fill="white"/>
				</svg>
				{/* A one-off product has no direct debit; its price is simply the price. */}
				{isSubscription(offer) ? 'Monthly direct debit' : 'Price'}: {formatPriceWithCurrency(getOfferPrice(offer), currency)}
			</div>
			<div className="flex gap-2">
				<div className="w-[14px] h-[14px]"/>
				{/* An estimate: the exact, API-calculated total is shown at the payment step. */}
				<div>
					Estimated total:{' '}
					{hasDiscount && <span className="line-through opacity-60 mr-1">{formatPriceWithCurrency(summary.amountTotal, currency)}</span>}
					{formatPriceWithCurrency(hasDiscount ? discountedTotal : summary.amountTotal, currency)}
				</div>
			</div>
		</div>
	</>);
}

export default SummaryMobile;
